module.exports = __webpack_public_path__ + "media/images/riders/MATTHIAS_STRINEMANN-e3675cf417283532a0767cfb1adf461d.png";